import type { Market } from '@backmarket/http-api'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'
import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from './routes.constants'

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const defaultLocale = toBcp47Locale(market.defaultLocale)

  return [
    {
      path: `/:locale(${defaultLocale})/search`,
      name: ROUTES.SEARCH_RESULTS,
      meta: { disableClientSideNavigation: () => true },
      component: () => import('./pages/SearchResultPage/SearchResultPage.vue'),
    },
    {
      path: `/:locale(${defaultLocale})/s/:merchantName/:uuid`,
      name: ROUTES.SELLER_PRODUCT_LIST,
      meta: { disableClientSideNavigation: () => true },
      component: () =>
        import('./pages/SellerProductListPage/SellerProductListPage.vue'),
    },
    {
      path: `/:locale(${defaultLocale})/l/:slugV2(.*?)/:uuid`,
      name: ROUTES.PRODUCT_LIST,
      meta: { disableClientSideNavigation: () => true },
      component: () => import('./pages/ProductListPage.vue'),
    },
  ]
}
